import { Page } from "table-engine";
import { roleTable } from "./config/tables";

export default function RolePage() {
    return <Page table={roleTable} />;
}
